import React, { useState, useEffect } from "react";
import Cookies from "js-cookie"; // Assure-toi d'avoir installé js-cookie
import { Link } from "react-router-dom"; // Pour utiliser le Link vers la page Cookies Policy

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  // Vérifie si le cookie de consentement existe déjà
  useEffect(() => {
    const cookiesAccepted = Cookies.get("cookies-accepted");
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  // Accepter les cookies
  const acceptCookies = () => {
    Cookies.set("cookies-accepted", "true", { expires: 365 });
    setShowBanner(false);
  };

  // Refuser les cookies
  const rejectCookies = () => {
    Cookies.set("cookies-accepted", "false", { expires: 365 });
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="cookie-banner">
        <div className="cookie-content">
          <span className="cookie-text">
            Ce site utilise des cookies pour améliorer votre expérience. En
            continuant, vous acceptez notre utilisation des cookies.
          </span>
          <div className="cookie-buttons">
            <button onClick={acceptCookies} className="btn-accept">
              Accepter
            </button>
            <button onClick={rejectCookies} className="btn-reject">
              Refuser
            </button>
            <Link to="/cookiespolicy" className="btn-more">
              Savoir plus
            </Link>
          </div>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
